/*
 *  Copyright (C) Serfim TIC
 * All rights reserved
 */

import { Filter } from '../../../model/Filter';
import { BaseController } from '../../BaseController';

class PreventiveSheetImportsExportsController extends BaseController {
    /** @ngInject */
    constructor(configuration, preventiveSheetService, siteService, equipmentService, dateTimeService,
        waitSpinnerService, $q, $state, $stateParams, $log, notificationService, $scope, $translate, filterService, dialogService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.preventiveSheetService = preventiveSheetService;
        this.siteService = siteService;
        this.equipmentService = equipmentService;
        this.dateTimeService = dateTimeService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$translate = $translate;
        this.$log.debug('Controller \'PreventiveSheetImportsExports\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.exportTypeFilter = null;
        this.downloadExport = {
            disabled: true,
            id: ''
        };
        this.importButton = {
            disabled: false
        };
        this.importStatus = "";
        this.initFilters();
        this.initCommands();
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {

        this.exportTypeFilter = Filter.equalFilter('export', this.exports, 'ui.preventivesheet.exporttype', 'SELECT',
            'SELECT', [{
                id: 'NORMAL',
                labelKey: 'ui.preventivesheet.normal'
            },{
                id: 'SV',
                labelKey: 'ui.preventivesheet.vocal'
            },{
                id: 'BN',
                labelKey: 'ui.preventivesheet.bollard'
            }]);

        this.importTypeFilter = Filter.equalFilter('import', this.imports, 'ui.preventivesheet.importtype', 'SELECT',
            'SELECT', [{
                id: 'NORMAL',
                labelKey: 'ui.preventivesheet.normal'
            },{
                id: 'SV',
                labelKey: 'ui.preventivesheet.vocal'
            },{
                id: 'BN',
                labelKey: 'ui.preventivesheet.bollard'
            }]);


        /* Init  date filter or export*/
        let today = new Date();
        this.startDateFilter = Filter.greaterOrEqualDateFilter('maxActionDate',
            this.dateTimeService.getFirstDayOfYearOfPreviousMonth(today), 'ui.preventivesheet.plannedfrom',
            filter => this.toLocalDate(filter));
        this.endDateFilter = Filter.lowerOrEqualDateFilter('maxActionDate',
            this.dateTimeService.getLastDayOfPreviousMonth(today), 'ui.preventivesheet.plannedto',
            filter => this.toLocalDate(filter));




        this.exportFilters = [
            this.exportTypeFilter,
            this.startDateFilter,
            this.endDateFilter
        ];

        this.importFilters = [
            this.importTypeFilter
        ];
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        // No command in the view.
    }

    /**
     * Converts import form data to valid DTO (form multiparts).
     *
     * @return {Object} Form multiparts, indexed by name.
     */
    convertImportToDto() {
        const formData = {
            attachment: this.attachment
        }
        return formData;
    }

    /**
     * Transforms a date filter to a local date value, before serialization in an HTTP request.
     *
     * @param {Filter} filter Filter.
     */
    toLocalDate(filter) {
        filter.value = this.dateTimeService.formatLocalDate(filter.value);
    }


    /**
     * Gets the exports.
     *
     * @return {Promise} A promise providing the content of the csv, or a rejection if no type of export was selected.
     */
    import() {
        let promise;
        if (!this.importTypeFilter.value && this.areAttachmentsValid(this.attachment)) {
            promise = false;
        } else {
            promise = this.preventiveSheetService.import(this.importTypeFilter.value, this.convertImportToDto());
            this.importButton.disabled = true;
            this.notificationService.pushMessage('ui.preventivesheetimportexport.importstart', this.configuration.NOTIFIER_LEVEL_INFO);
            this.$translate('ui.preventivesheetimportexport.importstart').then(translation => {
                this.importStatus += translation + "\n";
            });
            this.handleRestServiceCall(promise, () => {
                this.importButton.disabled = false;
                this.$translate('ui.preventivesheetimportexport.importsuccess').then(translation => {
                    this.importStatus += translation + "\n";
                });
                this.notificationService.pushMessage('ui.preventivesheetimportexport.importsuccess', this.configuration.NOTIFIER_LEVEL_INFO);
            });
        }
        return promise;
    }

    /**
     * Gets the exports.
     *
     * @return {Promise} A promise providing the content of the csv, or a rejection if no type of export was selected.
     */
    getExport() {
        this.downloadExport.disabled = true;
        let promise;
        if (!this.exportTypeFilter.value) {
            promise = false;
        } else {
            // Removes the 'export' filter from the filters that are sent in the request.
            const requestFilters = this.filterService.buildFilters(this.exportFilters);
            const exportFilterIndex = requestFilters.findIndex(filter => filter.key === 'export');
            if (exportFilterIndex >= 0) {
                requestFilters.splice(exportFilterIndex, 1);
            }
            promise = this.preventiveSheetService.generateExport(this.exportTypeFilter.value, requestFilters);
            promise.then(file => {
                this.downloadExport.id = file.id;
                this.downloadExport.disabled = false;
            });
        }
        return promise;
    }
}

export const preventiveSheetImportsExportsComponent = {
    template: require('./preventivesheetimportsexports.html'),
    controller: PreventiveSheetImportsExportsController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/component/PreventiveSheetImportsExports.js